import type {SxProps, Theme} from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import {useImpersonationAwareAuth} from '@src/hooks/dataCollections/impersonation/useImpersonationAwareAuth.ts';

type ImpersonationBannerProps = {
  sx?: SxProps<Theme>;
};

const ImpersonationBanner = ({sx}: ImpersonationBannerProps) => {
  const {impersonation, stopImpersonating} = useImpersonationAwareAuth();

  if (!impersonation.isImpersonating || !impersonation.hasImpersonationRights) {
    return null;
  }

  const impersonatedUserDisplayName = impersonation.impersonatedUser
    ? `${impersonation.impersonatedUser.givenName} ${impersonation.impersonatedUser.familyName}`
    : impersonation.impersonatedUserId;

  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={sx}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => stopImpersonating()}
        >
          Stop impersonating
        </Button>
      }
    >
      Managing user {impersonatedUserDisplayName}. Any changes you make will be
      applied to their account. Actions will <strong>not</strong> consume the
      user&rsquo;s quota.
    </Alert>
  );
};

export default ImpersonationBanner;
